import gql from 'graphql-tag';


// this looks at the user-id in the token
const Q_GET_MY_PROFILE = gql`
    query GetMyProfile($user_id: uuid) {
        v_user_profile(where: { id: { _eq: $user_id } }) {
            id,
            created_at,
            updated_at,
            username,
            email,
            system_user,
            invited_date,
            inviter_user_id,
            org_title,
            org_id,
            avatar,
            product_plan_title,
            product_plan_id
        }
    }
`;



export {
    Q_GET_MY_PROFILE
}




